import { FormData } from '../apps/AdmarktRegistration/types';

const saveStoreinSessionStorage = (name: string, value: FormData) => {
  const dataToSave = JSON.stringify(value);
  sessionStorage.setItem(name, dataToSave);
};

const getStoreFromSessionStorage = (name: string) => {
  try {
    const sessionItem = sessionStorage.getItem(name);

    if (!sessionItem) {
      return null;
    }

    return JSON.parse(sessionItem);
  } catch {
    return null;
  }
};

export { saveStoreinSessionStorage, getStoreFromSessionStorage };
